// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__Q8o52","row":"Node_row__23dqn","label":"Node_label__2Fqir","footer":"Node_footer__TWrpb"};